import { Page, Text, View, Document, StyleSheet, Font, Image } from "@react-pdf/renderer";
import { convertToJalali, formatGregorianDate } from "../../../../utils/date";
import { numberWithCommas } from "../../../../utils/utility";

import airArrowRight from "../../../../assets/icons/arrow-right-bold.png";
import airArrowLeft from "../../../../assets/icons/arrow-left-bold.png";

const IntFlightPdf = ({ orderItem }) => {
    function FlightDetailsContent({ uniqueId, details, passenger }) {
        const passengerType = passenger.type.toUpperCase();
        return (
            <div style={styles.rowGap}>
                {uniqueId && (
                    <div style={[styles.displayRow, styles.spaceBetween, styles.segment]}>
                        <div style={[styles.displayRow, styles.columnGap]}>
                            <Text style={styles.text}>po:</Text>
                            <Text style={styles.boldText}>{uniqueId}</Text>
                        </div>
                    </div>
                )}
                <div style={[styles.displayRow, styles.spaceBetween, styles.segment]}>
                    <div style={[styles.displayRow, styles.columnGap]}>
                        <Text style={styles.boldText}>{details?.departure?.terminal?.english_name + " - " + details?.departure?.terminal?.code}</Text>
                        <Text style={styles.text}>To</Text>
                        <Text style={styles.boldText}>
                            {details?.destination?.terminal?.english_name + " - " + details?.destination?.terminal?.code}
                        </Text>
                    </div>
                </div>
                <div style={[styles.displayRow, styles.spaceBetween, styles.segment]}>
                    <div style={[styles.displayRow, styles.columnGap]}>
                        <Text style={styles.text}>
                            Depart:{" "}
                            {/* {details?.departure_time?.split(":", 2).join(":")} , {details?.departure_date} */}
                            {formatGregorianDate(details?.departure_date, null, "dddd DD-MM-YYYY")},{" "}
                            {details?.departure_time?.split(":", 2).join(":")}
                        </Text>
                        <Text style={styles.text}>
                            Arrive:{" "}
                            {formatGregorianDate(details?.arrival_date, null, "dddd DD-MM-YYYY")},{" "}
                            {details?.destination_time?.split(":", 2).join(":")}
                        </Text>
                    </div>
                </div>
                <div style={[styles.displayRow, styles.spaceBetween]}>
                    <div style={[styles.displayRow, styles.columnGap]}>
                        <Image src={details?.airline?.image} style={styles.arrowIcon} />
                        <div>
                            <Text style={styles.boldText}>{details?.airline?.english} Airline</Text>
                            {!!details?.operating_airline?.english ? (
                                <Text style={styles.boldText}>(operating by {details?.operating_airline?.english})</Text>
                            ) : (
                                ""
                            )}
                        </div>
                        {!!details?.airline_pnr ? <Text style={styles.text}> Airline PNR: {details?.airline_pnr}</Text> : ""}
                    </div>
                    <div style={[styles.displayRow, styles.columnGap]}>
                        <Text style={[styles.boldText, styles.label]}>{details?.airline?.code + details?.flight_number}</Text>
                        <Text style={[styles.boldText, styles.label]}>{details?.airline.aircraft}</Text>
                        <Text style={[styles.boldText, styles.label]}>{details?.cobin}</Text>
                        <Text style={[styles.boldText, styles.label]}>{details?.type}</Text>
                        {passengerType !== "INF" && <Text style={[styles.boldText, styles.label]}>{details?.baggage} kg</Text>}
                    </div>
                </div>
            </div>
        );
    }
    // Font.register({
    //     family: "iranSans",
    //     src: persianFont,
    // });
    const styles = StyleSheet.create({
        page: {
            direction: "rtl",
            rowGap: 10,
            padding: "8px 20px",
            // fontFamily: "iranSans",
        },
        displayRow: {
            flexDirection: "row",
            alignItems: "center",
            columnGap: 2,
        },
        spaceBetween: {
            justifyContent: "space-between",
        },
        columnGap: {
            columnGap: 10,
        },
        rowGap: {
            rowGap: 2,
        },
        displayColumn: {
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-end",
        },
        section: {
            rowGap: 8,
        },
        logoImage: {
            width: 80,
            height: 16,
        },
        logoText: {
            color: "#006363",
            fontSize: 5,
            fontWeight: 700,
        },
        text: {
            fontSize: 8,
        },
        boldText: {
            fontSize: 8,
            fontWeight: 700,
        },
        title: {
            flexDirection: "row",
            padding: "2px 8px",
            backgroundColor: "#E6EBF0",
        },
        flightTitle: {
            flexDirection: "row",
            alignItems: "center",
            columnGap: 2,
            padding: "2px 16px",
            color: "#FFFFFF",
            backgroundColor: "#006363",
            fontSize: 8,
        },
        arrowIcon: {
            width: 5,
            height: 5,
        },
        segment: {
            padding: "2px 8px",
            backgroundColor: "#F7F7F7",
        },
        label: {
            padding: "2px 8px",
            border: "1px solid #808080",
            borderRadius: "10px",
        },
        price: {
            padding: "2px 8px",
            borderBottom: "1px solid #F0F0F0",
        },
        note: {
            color: "red",
        },
    });

    const ageType = {
        ADT: "Adult",
        CHD: "Child",
        INF: "Infant",
    };

    return (
        <Document>
            {orderItem?.flight?.segments[0]?.passengers?.map(passenger => {
                return (
                    <Page key={Math.random()} size="A4" style={styles.page}>
                        <View style={[styles.displayRow, styles.spaceBetween]}>
                            <div>
                                <Text style={styles.boldText}>Flight Ticket</Text>
                                <Text style={styles.boldText}>E-ticket Number:{passenger?.tickets[0]?.eticket_numbers}</Text>
                            </div>
                            <div>
                                <div style={[styles.displayRow, styles.spaceBetween]}>
                                    <Text style={styles.text}>Tracking Number:</Text>
                                    <Text style={styles.boldText}>{`${orderItem?.tracking_code}`}</Text>
                                </div>
                                <div style={[styles.displayRow, styles.spaceBetween]}>
                                    <Text style={styles.text}>Date of Issue:</Text>
                                    <Text style={styles.boldText}>{`${convertToJalali(orderItem?.create_date)}`}</Text>
                                </div>
                            </div>
                        </View>

                        <View style={styles.section}>
                            <div style={styles.title}>
                                <Text style={styles.boldText}>Passenger</Text>
                            </div>
                            <div style={styles.rowGap}>
                                <div style={[styles.displayRow, styles.columnGap]}>
                                    <Text style={styles.text}>Passenger Name:</Text>
                                    <Text style={styles.boldText}>
                                        {passenger?.english_first_name} {passenger?.english_last_name}
                                    </Text>
                                </div>
                                <div style={[styles.displayRow, styles.columnGap]}>
                                    {/* {!!passenger?.national_id ? (
                                        <div style={[styles.displayRow, styles.spaceBetween]}>
                                            <Text style={styles.text}>Nationality Code:</Text>
                                            <Text style={styles.boldText}>{passenger?.national_id}</Text>
                                        </div>
                                    ) : null} */}
                                    {!!passenger?.passport_number ? (
                                        <div style={[styles.displayRow, styles.spaceBetween]}>
                                            <Text style={styles.text}>Passport Number:</Text>
                                            <Text style={styles.boldText}>{passenger?.passport_number}</Text>
                                        </div>
                                    ) : null}
                                    <div style={[styles.displayRow, styles.spaceBetween]}>
                                        <Text style={styles.text}>Age:</Text>
                                        <Text style={styles.boldText}>{ageType[passenger?.type]}</Text>
                                    </div>
                                </div>
                            </div>
                        </View>

                        <View style={styles.section}>
                            <div style={styles.title}>
                                <Text style={styles.boldText}>Flights</Text>
                            </div>

                            <div style={styles.displayRow}>
                                <div style={styles.flightTitle}>
                                    <Image src={airArrowLeft} style={styles.arrowIcon} />
                                    <Text>Depart Flight</Text>
                                </div>
                            </div>

                            {orderItem?.flight?.segments.map(segment => {
                                return <FlightDetailsContent uniqueId={orderItem?.flight?.unique_id} details={segment} passenger={passenger} />;
                            })}

                            {!!orderItem?.flight?.return_segments?.length ? (
                                <div style={styles.displayRow}>
                                    <div style={styles.flightTitle}>
                                        <Image src={airArrowRight} style={styles.arrowIcon} />
                                        <Text>Return Flight</Text>
                                    </div>
                                </div>
                            ) : null}

                            {orderItem?.flight?.return_segments?.map(segment => {
                                return <FlightDetailsContent uniqueId={orderItem?.flight?.unique_id} details={segment} passenger={passenger} />;
                            })}
                        </View>

                        <View style={styles.section}>
                            {orderItem?.flight?.notes?.map(note => {
                                return <Text style={[styles.boldText, styles.note]}>{note?.note}</Text>;
                            })}
                        </View>

                        <View style={styles.section}>
                            <div style={styles.title}>
                                <Text style={styles.boldText}>Price</Text>
                            </div>

                            <div style={[styles.displayRow, styles.spaceBetween, styles.price]}>
                                <Text style={styles.boldText}>Price:</Text>
                                <Text style={styles.boldText}>{numberWithCommas(passenger?.total_price)} IRR</Text>
                            </div>
                        </View>

                        <View style={styles.section}>
                            <div style={styles.title}>
                                <Text style={styles.boldText}>Rules and Regulations</Text>
                            </div>

                            <div style={[styles.displayRow, styles.spaceBetween, styles.price]}>
                                <Text style={styles.text}>Cancellation fees will be calculated according to the airline’s regulations.</Text>
                            </div>
                            <div style={[styles.displayRow, styles.spaceBetween, styles.price]}>
                                <Text style={styles.text}>Dear passenger, you must be present at the airport 4 hours before the flight time.</Text>
                            </div>
                            <div style={[styles.displayRow, styles.spaceBetween, styles.price]}>
                                <Text style={styles.text}>
                                    In case of any restrictions regarding passenger acceptance, the company will not bear any responsibility, and all
                                    losses will be borne by the buyer.
                                </Text>
                            </div>
                        </View>
                    </Page>
                );
            })}
        </Document>
    );
};

export default IntFlightPdf;
